import React, { useState, useCallback } from 'react';
import styled from 'styled-components';

import { useClipboard } from 'use-clipboard-copy';
import { Button, Input } from '@agilytics/components';

import { defaultAction, defaultCopiedMessage } from './content.json';

const VisuallyHiddenLabel = styled.label`
  visibility: hidden;
`;

const Form = styled.form``;

const FormInner = styled.section`
  display: flex;
`;

const InputContainer = styled.div`
  flex: 2;

  > input {
    display: block;
    width: 100%;
  }
`;

const ButtonContainer = styled.div`
  flex: 1;
`;

const Alert = styled.figure`
  font-family: ${({ theme }) => theme.fonts.main};
`;

export default function CopyInput({ value, action = defaultAction, copiedMessage = defaultCopiedMessage }) {
  const [copied, setCopied] = useState(false);
  const { copy } = useClipboard();

  const onSubmit = useCallback(
    e => {
      e.preventDefault();

      setCopied(true);

      setTimeout(() => {
        setCopied(false);
      }, 2500);

      copy(value);
    },
    [copy, value, setCopied]
  );

  const labelId = `copy-label-${Math.floor(Math.random() * 1000)}`;

  return (
    <Form onSubmit={onSubmit} data-testid="copy-input-form">
      <VisuallyHiddenLabel id={labelId}>{action}</VisuallyHiddenLabel>
      <FormInner>
        <InputContainer>
          <Input aria-labelledby={labelId} value={value} readOnly />
        </InputContainer>
        <ButtonContainer>
          <Button data-testid="copy-input-button" type="submit">
            {action}
          </Button>
        </ButtonContainer>
      </FormInner>
      {copied ? <Alert>{copiedMessage}</Alert> : null}
    </Form>
  );
}
